import Zt from "./custom-event-data.js";
import is from "./custom-event-property-data.js";
import ts from "./filter-set.js";
import ni from "./in-app-message-click-data.js";
import rs from "./purchase-data.js";
import ns from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import tt from "./trigger-events.js";
import { logger as r } from "../../../shared-lib/index.js";
import { getErrorMessage as si } from "../../util/error-utils.js";
export default class ri {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  sc(e, t) {
    return ri.cc[this.type] === e && (null == this.data || this.data.Jl(t));
  }
  static if(e, t) {
    let s = null;
    try {
      s = window.atob(e);
    } catch (t) {
      return r.info("Failed to unencode analytics id " + e + ": " + si(t)), !1;
    }
    return t === s.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case ri._r.OPEN:
      case ri._r.kt:
        break;
      case ri._r.Rr:
        r = rs.fromJson(e.data);
        break;
      case ri._r.nc:
        r = ns.fromJson(e.data);
        break;
      case ri._r.vr:
        r = ur.fromJson(e.data);
        break;
      case ri._r.ue:
        r = Zt.fromJson(e.data);
        break;
      case ri._r.lc:
        r = is.fromJson(e.data);
        break;
      case ri._r.Qr:
        r = ni.fromJson(e.data);
    }
    return new ri(t, r);
  }
  Y() {
    return { t: this.type, d: this.data ? this.data.Y() : null };
  }
  static qn(e) {
    let t,
      r = null;
    switch (e.t) {
      case ri._r.OPEN:
      case ri._r.kt:
        break;
      case ri._r.Rr:
        r = new rs(e.d);
        break;
      case ri._r.nc:
        (t = e.d || {}), (r = new ns(t.id, ts.qn(t.pf || [])));
        break;
      case ri._r.vr:
        r = new ur(e.d);
        break;
      case ri._r.ue:
        r = new Zt(e.d);
        break;
      case ri._r.lc:
        (t = e.d || {}), (r = new is(t.e, ts.qn(t.pf || [])));
        break;
      case ri._r.Qr:
        r = new ni(e.d);
    }
    return new ri(e.t, r);
  }
}
(ri._r = {
  OPEN: "open",
  Rr: "purchase",
  nc: "purchase_property",
  vr: "push_click",
  ue: "custom_event",
  lc: "custom_event_property",
  Qr: "iam_click",
  kt: "test",
}),
  (ri.cc = {}),
  (ri.cc[ri._r.OPEN] = tt.OPEN),
  (ri.cc[ri._r.Rr] = tt.Rr),
  (ri.cc[ri._r.nc] = tt.Rr),
  (ri.cc[ri._r.vr] = tt.vr),
  (ri.cc[ri._r.ue] = tt.ue),
  (ri.cc[ri._r.lc] = tt.ue),
  (ri.cc[ri._r.Qr] = tt.Qr),
  (ri.cc[ri._r.kt] = tt.kt);
